import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ModalState = {
  name: string | null;
  show: boolean;
  data?: any;
};

type GeneralState = {
  modal: ModalState;
};

const initialState: GeneralState = {
  modal: {
    name: null,
    show: false,
  },
};

export const authSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    setShowModalAction: {
      reducer: (
        state,
        action: PayloadAction<{ show: boolean; name: string; data?: any }>,
      ) => {
        const { show, name, data } = action.payload;
        state.modal.show = show;
        state.modal.name = name;
        state.modal.data = data;
      },
      prepare: (name: string, show: boolean = true, data?: any) => {
        return {
          payload: { show, name, data },
        };
      },
    },
  },
  extraReducers: (builder) => {},
});

export const { setShowModalAction } = authSlice.actions;

export default authSlice.reducer;
